import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createProductInquiryService,
  updateProductInquiryService,
} from "../../api/productInquiryApi";

export const createProductInquiry = createAsyncThunk(
  "product/createProductInquiry",
  async (data) => {
    const response = await createProductInquiryService(data);
    return response.data;
  }
);

export const updateProductInquiry = createAsyncThunk(
  "product/updateProductInquiry",
  async (data) => {
    const response = await updateProductInquiryService(data);
    return response.data;
  }
);

const productInquirySlice = createSlice({
  name: "productInquiry",
  initialState: {
    status: null,
    msg: "",
    productInquiryLoader: false,
    productInquiry: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createProductInquiry.pending, (state) => {
        state.productInquiryLoader = true;
      })
      .addCase(createProductInquiry.fulfilled, (state, action) => {
        state.productInquiryLoader = false;
        state.productInquiry = action.payload;
      })
      .addCase(createProductInquiry.rejected, (state, action) => {
        state.productInquiryLoader = false;
        state.productInquiry = action.payload;
      })
      .addCase(updateProductInquiry.pending, (state) => {
        state.productInquiryLoader = true;
      })
      .addCase(updateProductInquiry.fulfilled, (state, action) => {
        state.productInquiryLoader = false;
        state.productInquiry = action.payload;
      })
      .addCase(updateProductInquiry.rejected, (state, action) => {
        state.productInquiryLoader = false;
        state.productInquiry = action.payload;
      });
  },
});

export default productInquirySlice.reducer;
